import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { href: "#come-funziona", label: "Come Funziona" },
  { href: "#chisiamo", label: "Chi Siamo" },
  { href: "#lanostrastoria", label: "La Nostra Storia" },
  { href: "#ilprogetto", label: "Il Progetto" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled
          ? "border-b border-white/5 bg-[#0A0A0A]/75 backdrop-blur-xl backdrop-saturate-150"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        {/* Logo a sinistra */}
        <a
          href="#top"
          data-testid="brand-logo"
          className="group flex items-center gap-0 flex-shrink-0"
        >
          <div className="flex items-center">
            <img 
              src="https://customer-assets-0z36b82j.emergentagent.net/job_zero-signals-landing/artifacts/jmp0fm2e_Logo%20FAMI%20-%20Logo%20ZS%20-%20Zeta%20%285%29.png" 
              alt="Zero Signals Logo" 
              className="h-10 w-auto object-contain" 
            />
          </div>

          <span className="font-display text-base font-bold tracking-tight">
            <img
              src="https://customer-assets-0z36b82j.emergentagent.net/job_zero-signals-landing/artifacts/03gyhn3g_Logo%20FAMI%20-%20Logo%20ZS%20-%20Zeta%20%288%29.png"
              alt="ZeroSignals"
              className="h-6 w-auto origin-left scale-[7.5] object-contain"
            />
          </span>
        </a>

        {/* Blocco Menu + CTA tutto spostato a destra su desktop */}
        <div className="hidden lg:flex items-center gap-8 ml-auto">
          <ul className="flex items-center gap-8">
            {LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`nav-link-${l.href.replace("#", "")}`}
                  className="group relative text-sm font-medium text-white/70 transition-colors hover:text-white"
                >
                  {l.label}
                  <span className="absolute -bottom-1 left-0 h-px w-0 bg-gradient-to-r from-brand-neon-blue to-brand-gold transition-all duration-300 group-hover:w-full" />
                </a>
              </li>
            ))}
          </ul>

          <a
            href="#the-hub"
            data-testid="nav-cta-join"
            className="group relative inline-flex items-center gap-2 rounded-full border border-brand-gold/50 bg-brand-gold/10 px-5 py-2 text-sm font-medium text-brand-gold transition-all hover:bg-brand-gold hover:text-black hover:shadow-[0_0_30px_-2px_rgba(0,240,255,0.55)]"
          >
            <span className="h-1.5 w-1.5 rounded-full bg-brand-neon-blue shadow-[0_0_8px_rgba(0,240,255,0.9)]" />
            Entra nell'Hub
          </a>
        </div>

        {/* Toggle per il mobile (resta a destra) */}
        <button
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
          className="grid h-10 w-10 place-items-center rounded-md border border-white/10 text-white/80 lg:hidden"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.2 }}
            className="lg:hidden"
          >
            <ul className="space-y-1 border-t border-white/5 bg-[#0A0A0A]/95 px-6 py-4 backdrop-blur-xl">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={() => setOpen(false)}
                    data-testid={`mobile-nav-link-${l.href.replace("#", "")}`}
                    className="block rounded-md px-3 py-3 text-sm font-medium text-white/80 hover:bg-white/5 hover:text-white"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="#hub"
                  onClick={() => setOpen(false)}
                  data-testid="mobile-nav-cta-join"
                  className="mt-2 block rounded-md border border-brand-gold/50 bg-brand-gold/10 px-3 py-3 text-center text-sm font-semibold text-brand-gold"
                >
                  Entra nell'Hub
                </a>
              </li>
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}